import { Country, Currency, CurrencyPosition } from './types';

export const getCurrencyFormattedCost = (
    locale: string,
    currency: Currency,
    cost: number,
    decimals = 2
) => {
    return Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        maximumFractionDigits: decimals,
    }).format(cost);
};

export const getCurrencyFormattedCostInParts = (locale: string, currency: Currency, cost = 0) =>
    Intl.NumberFormat(locale, { style: 'currency', currency }).formatToParts(cost);

export const getCurrencySymbol = (locale: string, currency: Currency) =>
    getCurrencyFormattedCostInParts(locale, currency).find((item) => item.type === 'currency')
        ?.value || '';

export const getCurrencyFromCountry = (country: Country) => {
    switch (country) {
        case Country.DK:
            return Currency.DKK;
        case Country.NO:
            return Currency.NOK;
        case Country.SE:
            return Currency.SEK;
        case Country.GB:
            return Currency.GBP;
        case Country.PL:
            return Currency.PLN;
        case Country.IS:
            return Currency.ISK;
        default:
            return Currency.EUR;
    }
};

export const getCurrencyPositionFromLocation = (locale: string) => {
    if (locale === 'en' || locale === 'en-GB' || locale === 'en-US') {
        return CurrencyPosition.PREFIX;
    }
    return CurrencyPosition.SUFFIX;
};
